/**
 * Rotas de `views/Geral/` (T88, R5 e R7).
 *
 * Saíram de `src/router/rotas/Geral.ts`, recortadas linha a linha. O hub — que
 * é grande e agrega rota de quase todo domínio — passou a importar estas duas
 * pelo barrel, como já fazia com Contratos, Materiais, Juridico, Apontamentos,
 * Biblioteca e ControleAcesso.
 *
 * **`Geral` não é um domínio de negócio**, e o R7 diz isso: "Os 8 `.vue` soltos
 * na raiz de `views/` não são domínios". É a "raiz explícita documentada" que
 * aquele mesmo item oferece como alternativa, e por isso a pasta não tem — nem
 * deve ter — `GeralApi.ts`, `Geral.type.ts`, `Geral.constantes.ts` ou
 * `papeis/geral.ts`.
 */

/** A home do sistema. */
export const rotaHome = [
  {
    path: "",
    name: "Home",
    props: true,
    component: () => import("@/views/Geral/GeralHome.vue"),
    meta: {
      showMenu: false,
    },
  },
];

/** A tela de versões, aberta pelo rodapé. */
export const rotaVersoesSistema = [
  {
    path: "/versoesSistema",
    name: "Versoes do Sistema",
    props: true,
    component: () => import("@/views/Geral/GeralVersoesSistema.vue"),
    meta: {
      showMenu: false,
    },
  },
];
